import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-carousel-example',
  templateUrl: './carousel.component.html',
})
export class KitBootstrapCarouselExampleComponent {}
